<template>
  <v-dialog
      :value="cambia"
      persistent
  >

          <v-row align="center" justify="center" class="text-center">
            <v-col cols="12" sm="12" md="8" lg="8">
             <v-card>
               <v-card-title>
               <v-row align="center" class="text-center">
                 <v-col cols="12" sm="12" md="12" lg="12">
                     Bienvenido, aqui puedes generar códigos para tus invitados , lo unico que debes hacer es escoger una fiesta, un tipo de lista y la cantidad que necesites.
                 </v-col>
               </v-row>
             </v-card-title>
               <v-card-text>
                <v-row>
                  <v-col  cols="12" sm="12" md="12">
                    <v-autocomplete  v-model="fiestaId" :items="fiestas" @change="dameMaximos" item-value="id" item-text="nombre"  persistent-hint

                                     single-line label="Escoger Fiesta"></v-autocomplete>
                  </v-col>
                  <v-col  cols="12" sm="12" md="12">
                    <v-alert
                        :value="alertatipolista"
                        color="error"
                        dark
                        dismissible
                        border="top"
                        transition="scale-transition"
                    >
                      Tiene que elegir un tipo de lista
                    </v-alert>
                    <v-autocomplete  v-model="tipoListaId" :items="tipolistas" @change="dameMaximos" item-value="tipoLista.id" item-text="tipoLista.tipoListaNombre"  persistent-hint

                                     single-line label="Escoger Tipo Lista"></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <p>Cantidad Maxima :  {{cantmax.cantidadmaxima}}</p>
                    <p>Cantidad en Lista Actualmente: {{cantmax.cantidadactual}}</p>
                    <p>Posibles :{{cantmax.posibles}}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col >
                      <v-alert
                              :value="alertacantidad"
                              color="error"
                              dark
                              dismissible
                              border="top"
                              transition="scale-transition"
                      >
                         La Cantidad no puede ser mayor a tus posibles
                      </v-alert>
                    <v-text-field v-model="cantidad" :max="maximo" @change="cambiaCantidad"  type="number" label="Cantidad de Codigos" append-outer-icon="fas fa-plus" @click:append-outer="incrementNo" prepend-icon="fas fa-minus" @click:prepend="decrementNo" ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn :disabled="botn" color="primary"  @click="save">Grabar</v-btn>
                  </v-col>
                  <v-col>
                    <v-btn text  @click="$emit('cierra')">Cerrar</v-btn>
                  </v-col>
                </v-row></v-card-text>
             </v-card>
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col md="8" lg="8" cols="12">
              <v-card>
                <v-card-title>Qr's Generados</v-card-title>
                <v-card-actions>
                  <v-row><v-col>Compartir</v-col></v-row>
                  <v-row>
                    <v-col><ShareNetwork
                        network="facebook"
                        :url="url"
                        :title="shtitle"
                        :description="shdescr"
                        :quote="shquote"
                        hashtags="tunay,listas"
                    >
                      <v-icon>fab fa-facebook</v-icon>
                    </ShareNetwork></v-col>
                    <v-col> <ShareNetwork
                        network="whatsapp"
                        :url="url"
                        :title="shtitle"
                        :description="shdescr"

                    >
                      <v-icon>fab fa-whatsapp</v-icon>
                    </ShareNetwork>
                    </v-col>

                    <v-col> <ShareNetwork
                        network="email"
                        :url="url"
                        :title="shtitle"
                        :description="shdescr"
                        hashtags="tunay,listas"
                    >
                      <v-icon>fas fa-envelope</v-icon>
                    </ShareNetwork>
                    </v-col>
                  </v-row>

                </v-card-actions>
                <v-card-text>

                  <v-row v-for="qr in qrs" :key="qr">
                    <v-col>
                      {{qr}}
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
  </v-dialog>

</template>

<script>
import axios from 'axios';
import moment from "moment";
export default {
  name: "qrlista",
  components: {
  },
  metaInfo() {
    return {
      title: this.titulonegocio,
        meta: [
      {property: "og:image", content: this.logoimg},
      {property: "og:image:width", content: "699"},
      {property: "og:image:height", content: "366"},
      {
        property: "og:description",
        content: "Lista de  "+this.titulonegocio
      }
    ]
    }
  },
  props:{
    promotor:{
      "id":1,
      "promotorNombre":"Nombre",
      "negocioTag": "negocioTag"
    },
    url : String,
    fiestas:[],
    tipolistas:[],
    cambia: Boolean
  },
  data () {
    return{
      md5promo: '',
      overlay:false,
      alertnuevo:false,
      logoexist: false,
      logoimg: null,
        alertacantidad:false,
      rese:'',
      browser:false,
      progr:false,
      mostrarlista:true,
      alertatipolista:false,
      botn: true,
      mobile:false,
      nombres:'',
      logo270:'',
      fiestaId:0,
      tipoListaId:0,
      search: '',
      styleCard:{

      },
      shtitle:'',
      shdescr:'',
      shquote:'',
      editedIndex: -1,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      headers: [
        { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Fiesta', align: 'left',  value: 'nombreActo'},
        { text: 'Fecha', value: 'fechaActo' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Tipo de Lista', value: 'tipoLista'},
        { text: 'Codigo para Registro', value: 'codigoUnico'},
      ],
      negocitag: '',
      qrs:[],
      cantidad:0,
      cantmax:{
        cantidadmaxima: 'Elija Fiesta y Tipo de Lista para obtener la cantidad',
        cantidadactual:'',
        posibles:''
      },
      maximo: 0,
      promotorId:0,
      txtcopia:'',
      dialogdelete: false,

      listas:[],
      styleColorLetra:{
        color: 'black'
      },
      Cardcolor:'black',
      stylePagina: {
        backgroundColor: 'black',
        color:'white',
        backgroundImage:'',
        backgroundSize: 'cover',
        height:"100%"

      },
      lista:{},
      editedItem: {
        id:0,
        listaFiesta:{
          id:0,
          titular:'',
          promotor:{},
          tipoLista:{},
          fiesta:{},
          createdAt: '2020-01-01 00:00:00'
        },
        nombre:'',
        codigoUnico:'',
        personaId:0,
        fechaIngreso:null,
        f:false,
        createdAt: '2020-01-01 00:00:00'
      },

    }
  }
  ,
  mounted (){
    let cantEs = document.documentElement.clientWidth;
    this.editedItem.listaFiesta.promotor = this.promotor

    if(cantEs<=450){
      this.mobile = true
    }

  }
,

  methods: {

    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    editItem (item) {
      this.editedIndex = this.listas.indexOf(item)
      this.lista = Object.assign({}, item)
      this.editedItem.listaFiesta.fiesta.fiestaInicio = this.formatDate(new Date(this.editedItem.listaFiesta.fiesta.fiestaInicio))
      this.editedItem.dateCreated = this.formatDateee(new Date(this.editedItem.dateCreated))
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.listas.indexOf(item);
      this.dialogdelete = true;
    },

    save () {
      if(this.tipoListaId>0) {
          if(this.cantidad <= this.maximo){
        this.overlay = true
        var bodyFormData = new FormData();
        bodyFormData.append("promotorId", this.promotor.id);
        bodyFormData.append("tipoListaId", this.tipoListaId);
        bodyFormData.append("fiestaId", this.fiestaId);
        bodyFormData.append("cantidad", this.cantidad);
        axios
            .post('lista/fiesta/qr', bodyFormData).then(response => {
          this.qrs = response.data;
          this.alertnuevo = true;
          this.overlay = false;
          this.dameMaximos()
          this.copiar()
        })
            .catch(error => {
              this.error = "Hubo un error";
              this.overlay = false;
              console.log(error);
            });
          }else{
              this.alertacantidad =true
          }
      }else
      {
        this.alertatipolista = true
      }
    },
    formatDarete (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD HH:mm:ss")
    },
    cambiaCantidad(){
      if(this.cantidad > this.maximo){
        this.cantidad = this.maximo
      }
    },
    copiar(){
      this.txtcopia = ''
      this.qrs.forEach(element => this.txtcopia= this.txtcopia + element + '\r\n')

      this.$copyText(this.txtcopia)
      if(this.rese !== "safari"){
        navigator.clipboard.writeText(this.txtcopia);
      }
      this.shtitle = 'Qrs para Lista'
      this.shdescr = 'Los QRs:\r\n'+ this.txtcopia

    },

    incrementNo () {
      if(this.cantidad<=this.maximo){
        this.cantidad = parseInt(this.cantidad,10) + 1}
    },
    decrementNo () {
      if(this.cantidad>0){
        this.cantidad = parseInt(this.cantidad,10) - 1
      }
    },
    dameMaximos(){
      let urlfiesta = 'promotores/maximos';
      var bodyFormData = new FormData();
      let fiest = this.fiestas.find(x=>x.id ===this.fiestaId)
      let fechamax = this.formatDateee(fiest.fechaInicio+' '+fiest.horaPromotorCierre)
      let hoy = this.formatDateee(new Date());
      if(fiest.sinLimite){
          this.botn = false
      }else{
      if (fechamax <= hoy ){
        if(this.promotor.superpromotor){
          this.botn = false
        }else{
          this.botn = true
        }
        this.botn = true
      }else{
        this.botn = false
      }}
      bodyFormData.append("personaId",this.promotor.id);

      bodyFormData.append("fiestaId",this.fiestaId);
      bodyFormData.append("tipoListaId",this.tipoListaId);
      if(this.tipoListaId>0 && this.promotor.id>0 && this.fiestaId>0){
        this.overlay = true

        axios
            .post(urlfiesta,bodyFormData)
            .then(response => {
              this.cantmax = response.data;
              this.maximo = this.cantmax.posibles
              this.overlay = false;
            })
            .catch((error)  => {
              console.error(error);
              this.overlay = false;
            });
      }
    }

  }
}
</script>

<style scoped>

</style>